import React, { Fragment, PureComponent } from 'react';
import { func, string } from 'prop-types';
import { Box } from '@mui/material';
import IntlMessages from '../../../util/IntlMessages';
import { Button } from '../../Button';

const MAX_TERMS_HEIGHT = 300;

/**
 * Represents stateless functional component TermsAndConditionsForm
 * Displays the latest T&C agreement and asks user to agree to them
 * @param {object} props Component props
 * @param {function} props.acceptTermsAndConditions Dispatches an action of a specific type
 * @param {String} props.text Represents the T&C text
 * @param {function} props.showAuthLoader Shows form loader if form is submitted
 * @return {Component}
 * */
class TermsAndConditionsForm extends PureComponent {
  static propTypes = {
    acceptTermsAndConditions: func,
    text: string,
    showAuthLoader: func,
  };

  static defaultProps = {
    acceptTermsAndConditions: () => {},
    text: '',
    showAuthLoader: () => {},
  };

  state = {
    termsRead: false,
  };

  componentDidMount() {
    // give the component some time to build up
    window.setTimeout(this.shouldSetTermsAsRead, 500);
  }

  componentDidUpdate() {
    this.shouldSetTermsAsRead();
  }

  acceptTermsAndConditions = () => {
    this.props.showAuthLoader();
    this.props.acceptTermsAndConditions();
  };

  shouldSetTermsAsRead = () => {
    if (!this.props.text || this.state.termsRead) {
      return;
    }

    const { clientHeight } = this.termsText;
    const { offsetHeight, scrollTop } = this.terms;

    if (clientHeight <= MAX_TERMS_HEIGHT || offsetHeight + scrollTop >= clientHeight) {
      this.setState({ termsRead: true });
    }
  };

  render() {
    return (
      <Fragment>
        <Box className="app-login-header" sx={{ mb: 3, textAlign: 'center' }}>
          <h2>
            <IntlMessages id="auth.terms.header" />
          </h2>
        </Box>
        <div className="app-login-form">
          <div
            className="terms-and-conditions"
            onScroll={this.shouldSetTermsAsRead}
            ref={terms => {
              this.terms = terms;
            }}
          >
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{ __html: this.props.text }}
              ref={termsText => {
                this.termsText = termsText;
              }}
            />
          </div>
          <Box sx={{ mt: 3, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Button
              size="large"
              labelId="auth.terms.buttonText"
              color="primary"
              disabled={!this.state.termsRead}
              onClick={this.acceptTermsAndConditions}
              variant="contained"
            />
          </Box>
        </div>
      </Fragment>
    );
  }
}

export default TermsAndConditionsForm;
